import VueRouter from 'vue-router';
import pluginRoutes from 'build/plugin-routes';
import standaloneRoutes from 'build/standalone-routes';

const routerMethods = ['push', 'replace'];
routerMethods.forEach((method) => {
  const originalMethod = VueRouter.prototype[method];
  VueRouter.prototype[method] = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalMethod.call(this, location, onResolve, onReject);
    return originalMethod.call(this, location).catch((err) => err);
  };
});

const Router = {
  install(Vue, { standalone, mountPath }) {
    let routes = pluginRoutes;

    if (standalone) {
      routes = standaloneRoutes;
    }

    const router = new VueRouter({
      mode: 'history',
      base: mountPath,
      routes,
    });

    Vue.prototype.$applicationRouter = router;

    Vue.mixin({
      beforeCreate() {
        if (!this.$parent && !this.$config.routerInitialized) {
          this.$options.router = router;
          this.$config.routerInitialized = true;
        }
      },
    });

    Vue.use(VueRouter);
  },
};

export default Router;
